import { UPDATE_CHAT_ON_PAGE } from '../actions';

export const chatOnPage = (state = false, action) => {
  switch (action.type) {
    case UPDATE_CHAT_ON_PAGE: {
      return action.chatOnPage;
    }
    default:
      return state;
  }
};
